import * as React from 'react';
import { AlternateDestinationList } from './internals/alternate-destination-list';
import { AlternateDestination } from 'src/common/models';
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';

export interface AlternateDestinationsProps {
  title: string;
  destinations?: AlternateDestination[];
  variant?: number;
}

const REQUIRED_DESTINATIONS: number = 2;

export class AlternateDestinations extends React.Component<AlternateDestinationsProps> {
  public render() {
    const { destinations, title } = this.props;

    if (!destinations || destinations.length < REQUIRED_DESTINATIONS) {
      return null;
    }

    return (
      <AbacusExperiment name="Alt_Destinations_HSR_Recommender">
        <AbacusControl />
        <AbacusVariant bucket={1}>
          <AlternateDestinationList destinations={destinations} title={title} variant={1} />
        </AbacusVariant>
        <AbacusVariant bucket={2}>
          <AlternateDestinationList destinations={destinations} title={title} variant={2} />
        </AbacusVariant>
        <AbacusVariant bucket={3}>
          <AlternateDestinationList destinations={destinations} title={title} variant={3} />
        </AbacusVariant>
        <AbacusVariant bucket={4}>
          <AlternateDestinationList destinations={destinations} title={title} variant={4} />
        </AbacusVariant>
      </AbacusExperiment>
    );
  }
}
